import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
// import Box from 'common/Box';
// import Link from 'common/Link';
import InsuranceLink from 'insurance/Link';
import * as routes from 'app/routes';
import { getBypassedSubscription } from 'reducers'
// import add_green_circle from 'common/img/add_green_circle.svg';
import styles from './Subscription.module.css';

export const SubscriptionScreen = ({ subId, sub }) => {
  return (
    <div className={cn('Subscription', styles.wrapper)}>
      <SubscriptionSwitcher
        bypassedSubId={subId}
        bypassedRoute={routes.bypassedSubscription}
        sprintRoute={routes.sprintSubscription}
        quickRoute={routes.quickSubscription}
      />
      <div className={styles.linkList}>
        {/* {sub && !(sub.bypassed_status === 'active' && false)  && // only for synced subs
          (
            <Link className={styles.subscriptionLink} to={routes.bypassedAddData(subId)}>
              <Box>
                <img src={add_green_circle} />
                Add Data
              </Box>
            </Link>
          )} */}
        <InsuranceLink className={styles.subscriptionLink} bypassedSubId={subId} />
      </div>
    </div>
  )
}

const mapStateToProps = (state, { subId }) => ({
  sub: getBypassedSubscription(state, subId),
})

export default connect(mapStateToProps, null)(SubscriptionScreen);
